<template>
  <div class="container is-fluid">
    <b-tabs v-model="activeTab">
      <b-tab-item label="Users">
        <user-settings/>
      </b-tab-item>
      <b-tab-item label="External APIs">
        <external-settings/>
      </b-tab-item>
    </b-tabs>

  </div>
</template>

<script>
import UserSettings from '@/components/UserSettings'
import ExternalSettings from '@/components/ExternalSettings'

export default {
  name: 'AdminPage',
  components: {
    UserSettings,
    ExternalSettings
  },
  data () {
    return {
      activeTab: 0
    }
  }
}
</script>

<style scoped>

</style>
